import { AddressDraft } from "@modules/address/addressTypes"
import {
  HidableAttributeFloat,
  HidableAttributeGenderCategory,
  HidableAttributeString,
} from "@modules/auth/userProfileTypes"
import { HUImageDraft } from "@modules/dtos/imageDto"
import { HUImage } from "@modules/types/imageTypes"

export const ProfileTypeOf = "USER_PROFILE"

export type User = {
  id: string
  _type: typeof ProfileTypeOf
  firstname: string
  lastname: string
  username: string
  avatar?: HUImage
}

export type Coach = {
  id: string
  _type: typeof ProfileTypeOf
  firstname: string
  lastname: string
  username: string
  avatar?: HUImage
  stripeAccountInError: boolean
}

export type ProfileDraft = {
  firstname: string
  lastname: string
  username: string
  avatar?: HUImageDraft
  genderCategory?: HidableAttributeGenderCategory
  birthdate?: HidableAttributeString
  address?: AddressDraft
  nationality?: HidableAttributeString
  weight?: HidableAttributeFloat
  height?: HidableAttributeFloat
}

export type RequestsSASProfile = {
  subscriptionId: string
  subscriptionDate: Date
  profile: User
}
